import React, { useState } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

export const HeldJobBanner = ({ mr, onDone }) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  if (mr.automation_held !== 'agent_manages') return null;

  const handOver = async (e) => {
    e.stopPropagation();
    setBusy(true); setError('');
    try {
      const r = await fetch(`${API}/api/maintenance/requests/${mr.id}/hand-to-estatel`, {
        method: 'POST', credentials: 'include',
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(typeof d.detail === 'string' ? d.detail : 'Could not hand over this job.');
      onDone && onDone();
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid={`kanban-card-held-${mr.id}`} onClick={e => e.stopPropagation()}
         style={{ marginTop: 6, padding: '6px 8px', background: '#f1f5f9', border: '1px solid #cbd5e1',
                  borderRadius: 6, fontSize: '0.72rem', color: '#334155' }}>
      <div style={{ fontWeight: 700, letterSpacing: '0.02em' }}>AGENT MANAGES — NO CONTRACTOR CONTACTED</div>
      <button type="button" onClick={handOver} disabled={busy}
              data-testid={`kanban-card-hand-to-estatel-${mr.id}`}
              style={{ marginTop: 5, background: '#0073EA', color: '#fff', border: 'none', borderRadius: 5,
                       padding: '3px 9px', fontSize: '0.72rem', fontWeight: 600,
                       cursor: busy ? 'wait' : 'pointer' }}>
        {busy ? 'Handing over…' : 'Hand to Estatel AI'}
      </button>
      {error && <div data-testid={`kanban-card-hand-error-${mr.id}`} style={{ color: '#b91c1c', marginTop: 4 }}>{error}</div>}
    </div>
  );
};
